import { IconButton, Stack, Badge, Popover, Box, ListItemButton, List } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import apiCNP from "../services/apiCNP";


export default function MunicipioFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [municipios, setMunicipios] = useState([]);
  const open = Boolean(anchorEl);
  const onClose = () => {
    setAnchorEl(null);
  };

  const provinciaIdFromStorage = localStorage.getItem("provinciaId") || "";

  useEffect(() => {
    if (props?.provinciaId || provinciaIdFromStorage) {
      apiCNP.get(`/municipios-by-provincia/${provinciaIdFromStorage || props.provinciaId}`)
        .then(res => {
          setMunicipios(res.data.municipios);
        }).catch(err => console.log(err))
    }
  }, [props?.provinciaId]);


  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.municipio}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.municipio === ""}
              onClick={(event) => {
                props.setMunicipio("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>
            {municipios?.map((municipio) => (
              <ListItemButton
                key={municipio._id}
                selected={props?.municipio === municipio?.designacao}
                onClick={(event) => {
                  props.setMunicipio(municipio?.designacao);
                  onClose();
                }}
              >
                {municipio.designacao}
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


